module.exports = __webpack_public_path__ + "7c4056584a477c16baf6ccda91110a0e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-10.png
// module id = 3237
// module chunks = 0